<template>
 <TabBasic
  v-if="order"
  v-model:activeKey="activeKey"
  color="#ffffff"
  tabPosition="top"
 >
  <Child :key="1">
   <template #tab>
        <span>
          <sdFeatherIcons size="18" type="trending-up"/>
          Informatie
        </span>
   </template>
   <div>
    <a-row :gutter="25" type="flex">
     <a-col :md="12" :xs="24" style="display: flex;flex-flow: column;">
      <sdCards v-if="order.extraData" title="ROI Gegevens">
       <a-row :gutter="30">
        <a-col :md="12" :xs="24" class="mb-25">
         <InfoWrapper v-if="order.extraData.consumption_peak && order.extraData.consumption_peak !== '' && order.extraData.consumption_peak !== '0'">
          <div class="info-title">Energieverbruik hoog</div>
          <div class="info-text">{{ order.extraData.consumption_peak }} kWh</div>
         </InfoWrapper>
         <InfoWrapper v-if="order.extraData.consumption_offpeak && order.extraData.consumption_offpeak !== '' && order.extraData.consumption_offpeak !== '0'">
          <div class="info-title">Energieverbruik laag</div>
          <div class="info-text">{{ order.extraData.consumption_offpeak }} kWh</div>
         </InfoWrapper>
         <InfoWrapper v-if="order.extraData.feedin_peak && order.extraData.feedin_peak !== '' && order.extraData.feedin_peak !== '0'">
          <div class="info-title">Energieteruglevering hoog</div>
          <div class="info-text">{{ order.extraData.feedin_peak }} kWh</div>
         </InfoWrapper>
         <InfoWrapper v-if="order.extraData.feedin_offpeak && order.extraData.feedin_offpeak !== '' && order.extraData.feedin_offpeak !== '0'">
          <div class="info-title">Energieteruglevering laag</div>
          <div class="info-text">{{ order.extraData.feedin_offpeak }} kWh</div>
         </InfoWrapper>
         <InfoWrapper v-if="order.extraData.number_of_solar_panels && order.extraData.number_of_solar_panels !== '' && order.extraData.number_of_solar_panels !== '0'">
          <div class="info-title">Aantal zonnepanelen</div>
          <div class="info-text">{{ order.extraData.number_of_solar_panels }} panelen</div>
         </InfoWrapper>
         <InfoWrapper v-if="order.extraData.usage_hours && order.extraData.usage_hours !== ''">
          <div class="info-title">Piekverbruik tijden</div>
          <div class="info-text">{{ order.extraData.usage_hours }}</div>
         </InfoWrapper>
        </a-col>
        <a-col :md="12" :xs="24" class="mb-25">
         <InfoWrapper v-if="order.extraData.physical_capacity && order.extraData.physical_capacity !== ''">
          <div class="info-title">Fysieke capaciteit</div>
          <div class="info-text">{{ order.extraData.physical_capacity }}</div>
         </InfoWrapper>
         <InfoWrapper v-if="order.extraData.contract_end_date && order.extraData.contract_end_date !== ''">
          <div class="info-title">Contract einddatum</div>
          <div class="info-text">{{ formatContractDate(order.extraData.contract_end_date) }}</div>
         </InfoWrapper>
         <InfoWrapper v-if="order.extraData.contract_type && order.extraData.contract_type !== ''">
          <div class="info-title">Contract type</div>
          <div class="info-text">{{ formatContractType(order.extraData.contract_type) }}</div>
         </InfoWrapper>
         <InfoWrapper v-if="order.extraData.taxable_income && order.extraData.taxable_income !== '' && order.extraData.taxable_income !== '0'">
          <div class="info-title">Belastbaar inkomen</div>
          <div class="info-text">{{ formatIncome(order.extraData.taxable_income) }}</div>
         </InfoWrapper>
         <InfoWrapper v-if="order.extraData.customer_wishes && order.extraData.customer_wishes !== ''">
          <div class="info-title">Klantbehoefte</div>
          <div class="info-text">{{ order.extraData.customer_wishes }}</div>
         </InfoWrapper>
         <InfoWrapper v-if="order.extraData.usage_months && order.extraData.usage_months !== ''">
          <div class="info-title">Gebruiksmaanden</div>
          <div class="info-text">{{ order.extraData.usage_months }}</div>
         </InfoWrapper>
        </a-col>
       </a-row>
      </sdCards>
     </a-col>
     <a-col :md="12" :xs="24" style="display: flex;flex-flow: column;">
      <sdCards title="Informatie">
       <a-row :gutter="30">
        <a-col :md="12" :xs="24" class="mb-25">
         <InfoWrapper>
          <div class="info-title">Naam</div>
          <div class="info-text">
           <template v-if="order.relationRevision.type==='CONSUMER'">
            <span>{{
              order.relationRevision.gender === 'MALE' ? 'Dhr.' : ''
             }}{{
              order.relationRevision.gender === 'FEMALE' ? 'Mevr.' : ''
             }} {{
              order.relationRevision.firstName
             }}{{
              order.relationRevision.middleName && order.relationRevision.middleName !== '' ? ` ${order.relationRevision.middleName}` : ''
             }} {{ order.relationRevision.lastName }}</span>
           </template>
           <template v-if="order.relationRevision.type==='BUSINESS'">
            <sdFeatherIcons size="14" type="briefcase"/>
            <span>{{ order.relationRevision.companyName }}<br/>{{
              order.relationRevision.companyCocNumber
             }}</span>
           </template>
          </div>
         </InfoWrapper>
         <InfoWrapper>
          <div class="info-title">Adres</div>
          <div class="info-text"> {{ order.relationRevision.street }} {{
            order.relationRevision.houseNumber
           }}{{
            order.relationRevision.houseNumberAddition && order.relationRevision.houseNumberAddition !== '' ? order.relationRevision.houseNumberAddition : ''
           }}<br/>{{ order.relationRevision.postalCode }} {{
            order.relationRevision.city
           }} {{ order.relationRevision.country === 'NL' ? 'Nederland' : '' }}
          </div>
         </InfoWrapper>
         <InfoWrapper>
          <div class="info-title">Status</div>
          <div class="info-text">{{ order.statusName }}</div>
         </InfoWrapper>
         <InfoWrapper v-if="order.externalReference">
          <div class="info-title">Uitgaande ID</div>
          <div class="info-text">{{ order.externalReference }}</div>
         </InfoWrapper>
         <InfoWrapper>
          <div class="info-title">Datum aangemaakt</div>
          <div class="info-text">{{ moment(order.createTimestamp).format('DD-MM-YYYY HH:mm:ss') }}</div>
         </InfoWrapper>
         <InfoWrapper>
          <div class="info-title">Datum geupdate</div>
          <div class="info-text">{{ moment(order.modifiedTimestamp).format('DD-MM-YYYY HH:mm:ss') }}</div>
         </InfoWrapper>
         <InfoWrapper v-if="order.expiryTimestamp">
          <div class="info-title">Verloopt op</div>
          <div class="info-text">{{ moment(order.expiryTimestamp).format('DD-MM-YYYY HH:mm:ss') }}</div>
         </InfoWrapper>
        </a-col>
        <a-col :md="12" :xs="24" class="mb-25">
         <InfoWrapper>
          <div class="info-title">Consument / Zakelijk</div>
          <div class="info-text">{{
            order.relationRevision.type === 'CONSUMER' ? 'Consument' : ''
           }}{{ order.relationRevision.type === 'BUSINESS' ? 'Zakelijk' : '' }}
          </div>
         </InfoWrapper>
         <InfoWrapper>
          <div class="info-title">Type</div>
          <div class="info-text">{{
            order.signType === 'ESIGNATURE' ? 'Offerte' : ''
           }}{{ order.signType === 'SIGNATURE' ? 'Overeenkomst' : '' }}
          </div>
         </InfoWrapper>
         <InfoWrapper>
          <div class="info-title">Flow</div>
          <div class="info-text">ROI Rapport</div>
         </InfoWrapper>
         <InfoWrapper>
          <div class="info-title">Organisatie</div>
          <div class="info-text">{{ order.organizationName }}</div>
         </InfoWrapper>
         <InfoWrapper>
          <div class="info-title">Agent</div>
          <div class="info-text">{{ order.userFullName }}</div>
         </InfoWrapper>
         <InfoWrapper v-if="order.productRevision && order.productRevision.name">
          <div class="info-title">Product</div>
          <div class="info-text">{{ order.productRevision.name }}</div>
         </InfoWrapper>
         <InfoWrapper v-if="order.relationRevision && order.relationRevision.email">
          <div class="info-title">Email</div>
          <div class="info-text">{{ order.relationRevision.email }}</div>
         </InfoWrapper>
         <InfoWrapper v-if="order.relationRevision && order.relationRevision.phoneNumber">
          <div class="info-title">Telefoonnummer</div>
          <div class="info-text">{{ order.relationRevision.phoneNumber }}</div>
         </InfoWrapper>
        </a-col>
       </a-row>
      </sdCards>
     </a-col>
    </a-row>

    <!-- Customer Situation -->
    <a-row v-if="order.extraData && order.extraData.notes" :gutter="25">
     <a-col :xs="24">
      <sdCards class="mb-25" title="Huidige Situatie">
       <p style="margin: 0; line-height: 1.6;">{{ order.extraData.notes }}</p>
      </sdCards>
     </a-col>
    </a-row>

    <!-- Documents Section -->
    <a-row :gutter="25">
     <a-col :xs="24">
      <sdCards title="Documenten">
       <FilesListTable @showPdfViewer="showPdfViewer"/>
       <a-row class="mt-6">
        <a-col :sm="12" :xs="24">
         <div class="sDash_form-action">
          <a-button class="btn-signin" size="large" type="primary" @click.prevent="showFileUpload">
           Toevoegen
          </a-button>
         </div>
        </a-col>
       </a-row>
      </sdCards>
     </a-col>
    </a-row>

    <!-- Activities and Communication -->
    <a-row :gutter="25">
     <a-col :md="12" :xs="24">
      <TimelineBoxWrap>
       <sdCards title="Activiteit">
        <a-timeline mode="alternate">
         <a-timeline-item v-for="(item,index) in activity" :key="index">
          <template #dot>
           <SwEllipse color="#ADB4D2" size="10"/>
          </template>
          <h2><small>{{ moment(item.timestamp).format('DD-MM-YYYY HH:mm:ss') }} -
           {{ item.userFullName }}</small></h2>
          <div class="content-box">
           <div>
            {{ item.description }}
           </div>
          </div>
         </a-timeline-item>
        </a-timeline>
       </sdCards>
      </TimelineBoxWrap>
     </a-col>
     <a-col :md="12" :xs="24">
      <TimelineBoxWrap>
       <sdCards title="Communicatie">
        <a-timeline mode="alternate">
         <a-timeline-item v-for="(item,index) in communication" :key="index">
          <template #dot>
           <SwEllipse color="#ADB4D2" size="10"/>
          </template>
          <h2><small>{{ moment(item.displayTimestamp || item.sentTimestamp || item.createTimestamp).format('DD-MM-YYYY HH:mm:ss') }} -
           {{ item.userFullName }}</small></h2>
          <div class="content-box">
           <div>
                            <span class="mb-5">
                              {{ item.text }}
                            </span>
            <StepsStyle :current="item.currentStep" :status="item.failReason ? 'error' : ''"
                        class="mt-5" direction="vertical" size="small" step="direction">
             <a-step v-for="item in item.steps" :key="item.id" :description="item.description"
                     :title="item.title"/>
            </StepsStyle>
            <a v-if="item.sentTimestamp && (item.type === 'OFFERMAIL' || item.type === 'CONFIRMATIONMAIL' || item.type === 'MARKETINGMAIL') && order.abilities.actions.canDownloadEml"
               style="display:inline-block; margin-top:6px; font-size:12px; cursor:pointer;"
               @click="downloadEml(item)">
             <sdFeatherIcons size="13" type="download"/> Download .eml
            </a>
           </div>
          </div>
         </a-timeline-item>
        </a-timeline>
       </sdCards>
      </TimelineBoxWrap>
     </a-col>
    </a-row>

    <!-- Navigation (No Actions for ROI) -->
    <sdCards>
     <a-row>
      <a-col :sm="12" :xs="24">
       <div class="sDash_order-action">
        <sdButton class="btn-signin" type="light" @click="$router.replace('/order')">
         Terug
        </sdButton>
       </div>
      </a-col>
     </a-row>
    </sdCards>
   </div>
  </Child>
  <Child v-if="order && order.abilities.tabs.relation" :key="2">
   <template #tab>
        <span>
          <sdFeatherIcons size="18" type="users"/>
          Relatie
        </span>
   </template>
   <p v-if="order">
    <Relation
     :can-update-relation="order.abilities.actions.canUpdateRelation"
     :enable-birthday="false"
     :order-id="orderId"
     :relation="order.relationRevision"
     :show-card-save-button="true"
     :show-footer="false"
     :show-global-save-button="false"
     :showIBAN="false"
     type="ORDEREDIT"
    ></Relation>
   </p>
   <sdCards>
    <a-row>
     <a-col :sm="12" :xs="24">
      <div class="sDash_order-action">
       <sdButton class="btn-signin" type="light" @click="$router.replace('/order')">
        Terug
       </sdButton>
      </div>
     </a-col>
    </a-row>
   </sdCards>
  </Child>
  <Child v-if="order && order.abilities.tabs.script" :key="3">
   <template #tab>
        <span>
          <sdFeatherIcons size="18" type="file-text"/>
          Script
        </span>
   </template>
   <div v-if="script">
    <sdCards title="Voicelog">
     <a-row :gutter="30">
      <a-col :sm="4" :xs="24" class="mb-25" style="width: 100%;min-width: 100%;">
       <div v-html="script"></div>
      </a-col>
     </a-row>
    </sdCards>
    <sdCards>
     <a-row>
      <a-col :sm="12" :xs="24">
       <div class="sDash_order-action">
        <sdButton class="btn-signin" type="light" @click="$router.replace('/order')">
         Terug
        </sdButton>
       </div>
      </a-col>
     </a-row>
    </sdCards>
   </div>
  </Child>
 </TabBasic>
</template>

<script>
import {defineComponent, ref} from 'vue';
import {useRoute} from "vue-router";
import {Child, TabBasic} from "@/components/tabs/Style";
import {InfoWrapper, TimelineBoxWrap} from "@/view/styled";
import {SwEllipse} from "@/components/utilities/icons";
import {StepsStyle} from "@/view/orders/Style";
import FilesListTable from "@/view/orders/component/FilesTable";
import Relation from "@/components/relation/Relation";
import moment from "moment";
import VueTypes from "vue-types";
import {DataService} from "@/config/dataService/dataService";

const OrderDetailROI = defineComponent({
 name: 'OrderDetailROI',
 components: {
  TabBasic,
  Child,
  InfoWrapper,
  TimelineBoxWrap,
  SwEllipse,
  StepsStyle,
  FilesListTable,
  Relation,
 },
 emits: ['showPdfViewer', 'showFileUpload'],
 props: {
  order: VueTypes.object.def(null),
  script: VueTypes.object.def(null),
  activity: VueTypes.array.def([]),
  communication: VueTypes.array.def([]),
 },
 setup(props, { emit }) {
  const {params} = useRoute();
  const orderId = params.id;
  const activeKey = ref(1);

  const showPdfViewer = (data) => {
   emit('showPdfViewer', data);
  };

  const showFileUpload = () => {
   emit('showFileUpload');
  };

  const formatContractDate = (dateValue) => {
   if (!dateValue) return 'Niet opgegeven';
   try {
    const formatted = moment(dateValue);
    if (!formatted.isValid()) return 'Ongeldige datum';
    return formatted.format('DD-MM-YYYY');
   } catch (error) {
    return 'Ongeldige datum';
   }
  };

  const formatContractType = (type) => {
   if (!type) return 'Niet opgegeven';
   const typeMap = {
    'DYNAMIC': 'Dynamisch',
    'VARIABLE': 'Variabel',
    'FIXED': 'Vast',
    'Dynamisch': 'Dynamisch',
    'Variabel': 'Variabel',
    'Vast': 'Vast'
   };
   return typeMap[type] || type;
  };

  const formatIncome = (income) => {
   if (!income || income === 0) return 'Niet opgegeven';
   return `€ ${parseFloat(income).toLocaleString('nl-NL', {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
  };

  const downloadEml = async (item) => {
   try {
    const response = await DataService.getBlob(`/orders/${orderId}/communications/${item.id}/eml`);
    const url = window.URL.createObjectURL(new Blob([response.data], {type: 'message/rfc822'}));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `email-${item.id}.eml`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    // Revoking right after click() cancels larger downloads that are still being written.
    setTimeout(() => window.URL.revokeObjectURL(url), 60000);
   } catch (e) {
    console.error('Downloaden .eml mislukt', e);
   }
  };

  return {
   orderId,
   activeKey,
   moment,
   showPdfViewer,
   showFileUpload,
   formatContractDate,
   formatContractType,
   formatIncome,
   downloadEml,
  }
 }
});

export default OrderDetailROI;
</script>

<style scoped>

</style> 